import { normalizeLabel } from '../../../utils/normalizeLabel';
import { useState } from 'react';

export type ColorRadioProps = React.HTMLAttributes<HTMLDivElement> & {
	currentColor?: string;
	color: string;
	onClick: React.EventHandler<React.SyntheticEvent<HTMLLabelElement>>;
};

const GROW_DELTA = 0.5;
const SHRINK_DELTA = 0.15;

export const ColorRadio: React.FC<ColorRadioProps> = ({
	currentColor,
	color,
	onClick,
	tabIndex,
	className,
	...props
}) => {
	const [{ zoom }, set] = useState<React.CSSProperties>({ zoom: 1 });
	const grow = () => set({ zoom: 1 + GROW_DELTA });
	const normal = () => set({ zoom: 1 });
	const shrink = () => set({ zoom: 1 - SHRINK_DELTA });

	return (
		<div
			className={`color-radio${className ? ` ${className}` : ''}`}
			{...props}
		>
			<input
				type="radio"
				name="color"
				id={color}
				defaultChecked={currentColor === color}
			/>

			<label
				htmlFor={color}
				onClick={onClick}
				onMouseEnter={grow}
				onMouseLeave={normal}
				onTouchStart={shrink}
				onTouchCancel={normal}
				onTouchEnd={normal}
				onTouchMove={normal}
				onFocus={shrink}
				onBlur={normal}
				onMouseDown={shrink}
				onMouseUp={grow}
				onKeyUp={e => {
					if ([32, 13].includes(e.keyCode)) {
						onClick(e);
					}
				}}
				tabIndex={tabIndex}
				data-color={normalizeLabel(color)} // useful for e2e testing
			>
				<span
					className={'cursor-pointer color-span ' + color}
					style={{
						transform: `scale(${zoom})`,
						// transition: 'transform .5s ease-in-out'
						transition:
							'transform .5s cubic-bezier(0.1, -0.6, 0.2, 0)'
					}}
				/>
			</label>
		</div>
	);
};
